import React from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import SearchComponent from "./Searchcomponent";
import NavDropdown from 'react-bootstrap/NavDropdown';


const Header = () => {
  const containerStyle = {
    background: 'RGB(161,27,42)'
  }
    return(
        <>
        {['lg'].map((expand) => (
        <Navbar key={expand} expand={expand} style={containerStyle} >
          <Container className="justify-content-center" >
          <Navbar.Brand href="/" >
  <img src="/images/logo1.png" width="120" height="50"  alt="Kromsan" />
</Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas style={containerStyle}
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Kromsan
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body className="pl-3">
              
                <Nav >
                  <Nav.Link style={{ color: 'white' }}  href="/">Главная</Nav.Link>
                  <Nav.Link style={{ color: 'white' }}  href="/galery">Галерея</Nav.Link>
                  <Nav.Link style={{ color: 'white' }}  href="/about">О нас</Nav.Link>
                  <Nav.Link style={{ color: 'white' }}  href="/contact">Контакты</Nav.Link>
                  
                  <Navbar.Toggle aria-controls="navbar-light-example" />
<Navbar.Collapse id="navbar-light-example">
  <Nav>
    <NavDropdown
      id="nav-dropdown-light-example"
      title={<span style={{ color: 'white' }}>Каталог</span>}
      menuVariant="light"
    >
      <NavDropdown.Item href="/category/any_equipmentt">Нержавейка</NavDropdown.Item>
      <NavDropdown.Item href="/category/hot_equipmentt">Тепловое оборудование</NavDropdown.Item>
      <NavDropdown.Item href="/category/cold_equipmentt">Холодильное оборудование</NavDropdown.Item>
      <NavDropdown.Divider />
    </NavDropdown>
  </Nav>
</Navbar.Collapse>
        
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
            <SearchComponent/>
          </Container>
        </Navbar>
      ))}
      </>
    )
}

export default Header